const permitir_realizar_carga_de_codigo_inep = [
  {
    path: "/permitir-realizar-carga-de-codigo-inep",
    name: "permitir_realizar_carga_de_codigo_inep",
    meta: {
      breadCrumb: "Censo Escolar - Código Inep",
      allowedPermissions: [
        "inep_aluno_carga_codigo_inep",
        "inep_servidor_carga_codigo_inep",
        "inep_turma_atualizar_codigo_inep",
        "inep_matricula_atualizar_codigo_inep",
      ],
    },
    component: () =>
      import(
        "@/views/PermitirRealizarCargaDeCodigoInep/PermitirRealizarCargaDeCodigoInep.vue"
      ),
  },
];

export { permitir_realizar_carga_de_codigo_inep };
